import React from "react";
import { Provider } from "react-redux";

import Flujo from "./flujo.cmpt";

export default class RegistroAsistido extends React.Component {
	render() {
		return <Provider store={this.props.redux}>
			<Flujo />
		</Provider>;
	}
}


// WEBPACK FOOTER //
// ./src/gnp-registro-asistido/contenedor.cmpt.js